import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl, Button, Modal } from 'react-bootstrap';
import s from './ManageBannerList.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import messages from '../../../locale/messages';
import Link from '../../Link';
import addIcon from '../../../../public/Icons/addNewIcon.svg';
import EditIcon from '../../../../public/Icons/edit.png';
import TrashIcon from '../../../../public/Icons/bin.svg';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import getBanners, { deleteBanner, getAdminBannerShops, toggleAdminBannerAdAction } from '../../../actions/siteadmin/Banner/bannerActions';
import CustomPagination from '../../CustomPagination/CustomPagination';
import moment from 'moment';
import { getBannerPlacements, addBannerPlacement } from '../../../actions/siteadmin/Banner/bannerPlacementActions';
import { api, bannerUploadDir } from '../../../config';
import Switch from 'react-switch';
import Select from 'react-select';

function joinUrl(...parts) {
  return parts
    .map((part, i) => {
      if (i === 0) return part.replace(/\/+$/, '');
      return part.replace(/^\/+/, ''); 
    })
    .join('/');
}

class ManageBannerList extends React.Component {
  static propTypes = {
    banners: PropTypes.array,
    count: PropTypes.number,
    getBanners: PropTypes.func.isRequired,
    deleteBanner: PropTypes.func.isRequired,
    getAdminBannerShops: PropTypes.func.isRequired,
    toggleAdminBannerAdAction: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    placements: PropTypes.array,
    getBannerPlacements: PropTypes.func.isRequired,
    addBannerPlacement: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      search: '',
      placementFilter: '',
      typing: false,
      typingTimeout: 0,
      currentPage: 1,
      limit: 10,
      showPlacementModal: false,
      placementName: '',
      placementLabel: '',

      // Ad toggle modal state
      showAdModal: false,
      selectedBannerId: null,
      shopsOptions: [],
      selectedShop: null,
      searchLoading: false,
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handlePlacementChange = this.handlePlacementChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAddBanner = this.handleAddBanner.bind(this);
    this.paginationData = this.paginationData.bind(this);
    this.openPlacementModal = this.openPlacementModal.bind(this);
    this.closePlacementModal = this.closePlacementModal.bind(this);
    this.handlePlacementNameChange = this.handlePlacementNameChange.bind(this);
    this.handleSavePlacement = this.handleSavePlacement.bind(this);
    this.handlePlacementLabelChange = this.handlePlacementLabelChange.bind(this);

    this.handleAdToggle = this.handleAdToggle.bind(this);
    this.closeAdModal = this.closeAdModal.bind(this);
    this.handleShopSearch = this.handleShopSearch.bind(this);
    this.handleSaveAdSetup = this.handleSaveAdSetup.bind(this);
  }

  componentDidMount() {
    this.props.getBanners({ currentPage: 1, limit: this.state.limit });
    if (!this.props.placements || this.props.placements.length === 0) {
      this.props.getBannerPlacements();
    }
  }

  refetchBanners() {
    const params = { currentPage: this.state.currentPage, limit: this.state.limit };
    if (this.state.search && this.state.search.trim()) {
      params.tittle = this.state.search.trim();
    }
    if (this.state.placementFilter) {
      params.placementId = this.state.placementFilter;
    }
    this.props.getBanners(params);
  }

  handleSearchChange(e) {
    let self = this;
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }
    const value = e.target.value;
    self.setState({
      search: value,
      typing: false,
      typingTimeout: setTimeout(function () {
        const params = { currentPage: 1, limit: self.state.limit };
        if (value && value.trim()) {
          params.tittle = value.trim();
        }
        if (self.state.placementFilter) {
          params.placementId = self.state.placementFilter;
        }

        self.props.getBanners(params);
        self.setState({ currentPage: 1 });
      }, 300)
    });
  }

  handlePlacementChange(e) {
    const value = e.target.value;
    this.setState({ placementFilter: value });
    const params = { currentPage: 1, limit: this.state.limit };
    if (this.state.search && this.state.search.trim()) {
      params.tittle = this.state.search.trim();
    }
    if (value) {
      params.placementId = value;
    }
    this.props.getBanners(params);
    this.setState({ currentPage: 1 });
  }

  handleDelete(id) {
    const { intl } = this.props;
    if (window.confirm(intl.formatMessage(messages.confirmDelete))) {
      this.props.deleteBanner(id);
      setTimeout(() => {
        this.refetchBanners();
      }, 500);
    }
  }

  handleAddBanner() {
    // Navigation handled by Link
  }

  paginationData(currentPage) {
    this.setState({ currentPage });
    const params = { currentPage, limit: this.state.limit };
    if (this.state.search && this.state.search.trim()) {
      params.tittle = this.state.search.trim();
    }
    if (this.state.placementFilter) {
      params.placementId = this.state.placementFilter;
    }
    this.props.getBanners(params);
  }

  openPlacementModal() {
    this.setState({ showPlacementModal: true, placementName: '', placementLabel: '' });
  }

  closePlacementModal() {
    this.setState({ showPlacementModal: false, placementName: '', placementLabel: '' });
  }

  handlePlacementNameChange(e) {
    this.setState({ placementName: e.target.value });
  }

  handlePlacementLabelChange(e) {
    this.setState({ placementLabel: e.target.value });
  }

  async handleSavePlacement() {
    const { placementName, placementLabel } = this.state;
    await this.props.addBannerPlacement({ name: placementName, label: placementLabel });
    this.closePlacementModal();
    this.props.getBannerPlacements();
  }

  // Ad mutations handlers
  async handleAdToggle(bannerId, isChecked) {
    if (!isChecked) {
      if (window.confirm("Are you sure you want to disable advertisement for this banner? Performance metrics and history will be preserved.")) {
        const success = await this.props.toggleAdminBannerAdAction(bannerId, false, null);
        if (success) {
          this.refetchBanners();
        }
      }
    } else {
      this.setState({
        showAdModal: true,
        selectedBannerId: bannerId,
        selectedShop: null,
        shopsOptions: [],
        searchLoading: true,
      });

      // Load initial active shops list
      const shops = await this.props.getAdminBannerShops('');
      const options = shops.map(s => ({ value: s.id, label: `${s.shopName} (${s.email})` }));
      this.setState({ shopsOptions: options, searchLoading: false });
    }
  }

  closeAdModal() {
    this.setState({ showAdModal: false, selectedBannerId: null, selectedShop: null, shopsOptions: [] });
  }

  async handleShopSearch(inputValue) {
    this.setState({ searchLoading: true });
    const shops = await this.props.getAdminBannerShops(inputValue);
    const options = shops.map(s => ({ value: s.id, label: `${s.shopName} (${s.email})` }));
    this.setState({ shopsOptions: options, searchLoading: false });
  }

  handleShopSearchChange = (inputValue, { action }) => {
    if (action === 'input-change') {
      this.handleShopSearch(inputValue);
    }
  };

  async handleSaveAdSetup() {
    const { selectedBannerId, selectedShop } = this.state;
    if (!selectedShop) return;
    const success = await this.props.toggleAdminBannerAdAction(selectedBannerId, true, selectedShop.value);
    if (success) {
      this.closeAdModal();
      this.refetchBanners();
    }
  }

  render() {
    const { banners, count, intl, placements = [] } = this.props;
    const { currentPage, limit, placementFilter = '', showPlacementModal, placementName, placementLabel, showAdModal, shopsOptions, selectedShop, searchLoading } = this.state;
    return (
      <div className={cx(s.root)}>
        <div className={cx(s.widthInner)}>
          <div className={cx(s.exportDisplay)}>
            <div className={cx(s.searchFilterRow)}>
              <div className={s.searchInput}>
                <FormControl
                  type='text'
                  placeholder="Search ..."
                  onChange={this.handleSearchChange}
                  value={this.state.search}
                />
              </div>
              <div className="statusSelectWrapper" style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <select
                  value={placementFilter}
                  onChange={this.handlePlacementChange}
                  className={s.formControlInput}
                  style={{ minWidth: 160 }}
                >
                  <option value="">All Placement</option>
                  {placements && placements.map((placement) => (
                    <option key={placement.id} value={placement.id}>{placement.name}</option>
                  ))}
                </select>
               
                <Link to={'/siteadmin/banner/placement'} className={s.addlinkBtn} style={{marginLeft: 8, fontWeight: 500, fontSize: 14, padding: '0 12px', height: 35, display: 'flex', alignItems: 'center', borderRadius: 18, background: '#f5f5f5', color: '#333', border: '1px solid #ddd'}}>
                  Manage
                </Link>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
              <Link to={'/siteadmin/banner/add'} className={s.addlinkBtn}>
                <FormattedMessage {...messages.addBanner} />
                <span className={cx(s.addIconCss, 'addIconCssRTL')}><img src={addIcon} alt="Add" style={{ width: 22, height: 22 }} /></span>
              </Link>
            </div>
          </div>

          {/* Modal Tambah Placement */}
          <Modal show={showPlacementModal} onHide={this.closePlacementModal}>
            <Modal.Header closeButton>
              <Modal.Title>Add Placement</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div style={{ marginBottom: 16 }}>
                <label htmlFor="placementNameInput" style={{ marginBottom: 6, display: 'block', fontWeight: 500 }}>Name</label>
                <FormControl
                  id="placementNameInput"
                  type="text"
                  placeholder="Name"
                  value={placementName}
                  onChange={this.handlePlacementNameChange}
                  style={{ borderRadius: 8, height: 40 }}
                />
              </div>
              <div>
                <label htmlFor="placementLabelInput" style={{ marginBottom: 6, display: 'block', fontWeight: 500 }}>Label</label>
                <FormControl
                  id="placementLabelInput"
                  type="text"
                  placeholder="Label"
                  value={placementLabel}
                  onChange={this.handlePlacementLabelChange}
                  style={{ borderRadius: 8, height: 40 }}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closePlacementModal} style={{ borderRadius: 8, minWidth: 90 }}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.handleSavePlacement} disabled={!placementName.trim() || !placementLabel.trim()} style={{ borderRadius: 8, minWidth: 90 }}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          {/* Ad Setup Modal */}
          <Modal show={showAdModal} onHide={this.closeAdModal} enforceFocus={false} centered>
            <Modal.Header closeButton>
              <Modal.Title style={{ fontWeight: 600 }}>Enable Advertisement Setup</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ minHeight: 180 }}>
              <div style={{ marginBottom: 16 }}>
                <label htmlFor="shopSelectInput" style={{ marginBottom: 8, display: 'block', fontWeight: 500, fontSize: 14, color: '#333' }}>
                  Select Shop / Restaurant <span style={{ color: 'red' }}>*</span>
                </label>
                <Select
                  id="shopSelectInput"
                  options={shopsOptions}
                  value={selectedShop}
                  onChange={(option) => this.setState({ selectedShop: option })}
                  onInputChange={this.handleShopSearchChange}
                  placeholder="Type shop name to search..."
                  isLoading={searchLoading}
                  isClearable
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderRadius: 8,
                      minHeight: 42,
                      borderColor: '#ccc',
                      boxShadow: 'none',
                      '&:hover': {
                        borderColor: '#2684FF'
                      }
                    })
                  }}
                />
              </div>
              <p style={{ fontSize: 12, color: '#666', marginTop: 12 }}>
                * Banners marked as advertisements will start tracking mobile impression and click events linked to the selected restaurant storefront.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.closeAdModal} style={{ borderRadius: 8, minWidth: 95 }}>
                Cancel
              </Button>
              <Button variant="primary" onClick={this.handleSaveAdSetup} disabled={!selectedShop} style={{ borderRadius: 8, minWidth: 95 }}>
                Enable Ad
              </Button>
            </Modal.Footer>
          </Modal>

          <div className={cx(s.tableCss, 'tableCss', 'tableSticky')}>
            <Table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Image</th>
                  <th><FormattedMessage {...messages.tittle} /></th>
                  <th>Placement</th>
                  <th>Status</th>
                  <th style={{ textAlign: 'center' }}>Ad</th>
                  <th>Store / Shop</th>
                  <th style={{ textAlign: 'center' }}>Imps</th>
                  <th style={{ textAlign: 'center' }}>Clicks</th>
                  <th style={{ textAlign: 'center' }}>Orders</th>
                  <th>Locations</th>
                  <th><FormattedMessage {...messages.action} /></th>
                </tr>
              </thead>
              <tbody>
                {banners && banners.length > 0 ? banners.map((banner, idx) => {
                  const imageUrl = banner.imageUrl ? joinUrl(api.apiEndpoint, bannerUploadDir, banner.imageUrl) : null;
                  return (
                    <tr key={banner.id}>
                      <td>{(currentPage - 1) * limit + idx + 1}</td>
                      <td>
                        {imageUrl ? (
                          <img src={imageUrl} style={{ width: 64, height: 36, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee' }} alt="Banner" />
                        ) : (
                          <div style={{ width: 64, height: 36, background: '#f5f5f5', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 9, color: '#bbb' }}>No Img</div>
                        )}
                      </td>
                      <td>
                        <div style={{ fontWeight: 500, color: '#333' }}>{banner.tittle}</div>
                        {banner.description && <div style={{ fontSize: 11, color: '#777', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{banner.description}</div>}
                      </td>
                      <td>
                        <span style={{ fontSize: 12, padding: '2px 8px', borderRadius: 12, background: '#eef2f7', color: '#475e7a', fontWeight: 500 }}>
                          {banner.placement ? banner.placement.name : banner.placementId}
                        </span>
                      </td>
                      <td>
                        <span className={cx(s.statusBadge, {
                          [s.active]: banner.status === 'PUBLISHED',
                          [s.inactive]: banner.status === 'ARCHIVED',
                          [s.draft]: banner.status === 'DRAFT',
                        })}>
                          {banner.status}
                        </span>
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <Switch
                          checked={!!banner.isAd}
                          onChange={(checked) => this.handleAdToggle(banner.id, checked)}
                          onColor="#007bff"
                          offColor="#ccc"
                          checkedIcon={false}
                          uncheckedIcon={false}
                          height={20}
                          width={40}
                          handleDiameter={16}
                        />
                      </td>
                      <td>
                        {banner.isAd && banner.ad ? (
                          <div style={{ fontWeight: 500, color: '#2c3e50', fontSize: 13 }}>
                            {banner.ad.shopName || 'Unnamed Shop'}
                          </div>
                        ) : (
                          <span style={{ color: '#aaa', fontSize: 12 }}>—</span>
                        )}
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        {banner.isAd && banner.ad ? (
                          <span className={s.metricBadge} style={{ background: 'rgba(52, 152, 219, 0.1)', color: '#2980b9' }}>
                            {banner.ad.impressionCount || 0}
                          </span>
                        ) : <span style={{ color: '#bbb' }}>-</span>}
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        {banner.isAd && banner.ad ? (
                          <span className={s.metricBadge} style={{ background: 'rgba(46, 204, 113, 0.1)', color: '#27ae60' }}>
                            {banner.ad.clickCount || 0}
                          </span>
                        ) : <span style={{ color: '#bbb' }}>-</span>}
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        {banner.isAd && banner.ad ? (
                          <span className={s.metricBadge} style={{ background: 'rgba(155, 89, 182, 0.1)', color: '#8e44ad' }}>
                            {banner.ad.orderCount || 0}
                          </span>
                        ) : <span style={{ color: '#bbb' }}>-</span>}
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        {banner.locations && banner.locations.length > 0 ? (
                          <span title={banner.locations.map(l => l.locationName).join(', ')} style={{ fontSize: 12, padding: '2px 8px', borderRadius: 12, background: '#e8f4fd', color: '#1a73e8', fontWeight: 500, cursor: 'default' }}>
                            {banner.locations.length} location{banner.locations.length > 1 ? 's' : ''}
                          </span>
                        ) : (
                          <span style={{ fontSize: 12, color: '#888' }}>All Locations</span>
                        )}
                      </td>
                      <td style={{ verticalAlign: 'middle' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                          <Link to={`/siteadmin/banner/edit/${banner.id}`} className={cx('editAlignIcon', s.editColorIcon)} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} alt="Edit" style={{ width: 14, height: 14 }} /></span>
                            <span className={s.vtrMiddle}><FormattedMessage {...messages.editAction} /></span>
                          </Link>
                          <Button onClick={() => this.handleDelete(banner.id)} className={cx(s.iconBtn, 'iconBtnRTL')} style={{ padding: 0, border: 'none', background: 'transparent' }}>
                            <img src={TrashIcon} alt="Delete" style={{ width: 16, height: 16 }} />
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                }) : (
                  <tr>
                    <td colSpan="12" className={s.noData}><FormattedMessage {...messages.noData} /></td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {count > 0 && (
            <div className={cx('space5', 'spaceTop5')}>
              <CustomPagination
                total={count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={limit}
                change={this.paginationData}
                paginationLabel={'Banners'}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  banners: state.adminBanners && state.adminBanners.items,
  count: state.adminBanners && state.adminBanners.count,
  placements: state.adminBanners && state.adminBanners.placements
});

const mapDispatch = (dispatch) => bindActionCreators({ 
  getBanners, 
  deleteBanner, 
  getBannerPlacements, 
  addBannerPlacement,
  getAdminBannerShops,
  toggleAdminBannerAdAction
}, dispatch);

export default injectIntl(connect(mapState, mapDispatch)(withStyles(s)(ManageBannerList)));